/**
 * @generated SignedSource<<7dcc02a86183c137da8b39cb7746bb0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSidebarSellerInfoAndContact_user">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_user";
};
export type PdpRespSidebarSellerInfoAndContactLazy_user$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSidebarSellerInfoAndContact_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9be13d3f33af8a6a00447a94bff4a123";

export default node;
